import { render, staticRenderFns } from "./fccListaInclusaoAlteracao.vue?vue&type=template&id=7ab53a56"
import script from "./fccListaInclusaoAlteracao.vue?vue&type=script&lang=js"
export * from "./fccListaInclusaoAlteracao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports